import { useState, useEffect } from "react";

const Shorts = () => {
  const [short, setShort] = useState({});

  useEffect(() => {}, []);

  const getShort = async () => {};

  return <div>Shorts</div>;
};

export default Shorts;
